export interface CircleGraphPropsI {
  fill?: string;
  sectorFill?: string;
  width?: number;
  stroke?: string;
  strokeWidth?: number;
  angle: number;
}

const SIZE = 1000;
const RAD = SIZE/2;
const GAP = 0.1*SIZE;

export default function CircleGraph({
  fill = "green",
  sectorFill = "red",
  stroke = "blue",
  strokeWidth = 0.05,
  width=20,
  ...props
}: CircleGraphPropsI) {

  const angle = 2 * Math.PI * props.angle;
  const secX = Math.floor(Math.sin(angle) * RAD); // round заменил на floor, чтобы закрашивалось полностью при props.angle = 1
  const secY = -Math.floor(Math.cos(angle) * RAD);
  const flag = props.angle < 0.5 ? 0 : 1;
  const strwd = strokeWidth * SIZE;

  return (
    <svg width={width} height={width} viewBox={`0 0 ${SIZE + GAP * 2} ${SIZE + GAP * 2}`}>
      <g transform={`translate(${GAP} ${GAP})`}>
        <circle
          cx={RAD}
          cy={RAD}
          r={RAD}
          fill={fill}
          stroke={stroke}
          strokeWidth={strwd}
        />
        <path
          d={`M${RAD} ${RAD} v-${RAD} a${RAD} ${RAD} 0 ${flag} 1 ${secX} ${RAD+secY} z`}
          fill={sectorFill}
          stroke={stroke}
          strokeWidth={strwd}
        />
      </g> 
    </svg>
  )
}